/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import Polaris styles
import '@shopify/polaris/build/esm/styles.css';

// App-specific styling (switches, panels, scheduler UI)
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
